export default "__VITE_ASSET__BxNmu0UB__"